import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { Col, Row } from 'react-bootstrap';
import _ from 'lodash';
import EditLargeCard from '../main/edit-large-card';
import LeftSide from '../main/left-side';
import TitleCard from '../main/title-card';
import ObjectAddressForm from './forms/object-address-form';
import ObjectInfoForm, { MULTI_FAMILY_HOUSE } from './forms/object-info-form';
import translate from '../translate';
import {
    LoadMansions,
    RemoveMansion,
    UpdateMansion,
} from '../../store/mansionsSlice';
import { REQUEST_INITIAL } from '../../store/network/managedRequest';
import { goToMansionOverview } from '../../nav/navigationService';
import ShowOnDisabled from '../main/show-on-disabled';
import ConfirmButton from '../util/confirm-button';
import { PbRequest } from '../../store/pbRequest';
import withParams from '../../nav/withParams';

const defaultFields = {
    partner_id: '',
    mansion_type: MULTI_FAMILY_HOUSE,
    num_of_machines: '',
    housing_units: '',
    status: 0,
    address: {
        street: '',
        housenumber: '',
        city: '',
        description: '',
        postalcode: '',
        country_id: 1,
    },
};

const EditObject = createReactClass({
    displayName: 'EditObject',

    propTypes: {
        strings: PropTypes.object,
        params: PropTypes.shape({
            object_id: PropTypes.string,
        }).isRequired,
        LoadMansions: PropTypes.func.isRequired,
        UpdateMansion: PropTypes.func.isRequired,
        RemoveMansion: PropTypes.func.isRequired,
        mansionsById: PropTypes.shape({}).isRequired,
        loadMansionRequestStatus: PropTypes.string.isRequired,
        removeMansionErrors: PropTypes.arrayOf(PropTypes.string),
    },

    defaultProps: {
        title: ['Title', 'titley'],
        type: '',
        left: {
            content: null,
            title: null,
        },
        right: {
            content: null,
            title: null,
        },
    },

    getInitialState() {
        return {
            mansion: undefined,
            isObjectFormValid: undefined,
        };
    },

    componentDidMount() {
        if (this.props.loadMansionRequestStatus === REQUEST_INITIAL) {
            this.props.LoadMansions();
        }
    },

    getMansionFromStores() {
        const mansionId = this.props.params.object_id;
        if (mansionId && this.props.mansionsById[Number(mansionId)]) {
            return this.props.mansionsById[Number(mansionId)];
        }
        return defaultFields;
    },

    getCombinedMansion() {
        return { ...this.getMansionFromStores(), ...this.state.mansion };
    },

    _removeMansion() {
        this.props.RemoveMansion(this.props.params.object_id, () =>
            goToMansionOverview()
        );
    },

    getDeleteErrorMessage() {
        let errorMessage = null;
        const errors = this.props.removeMansionErrors;
        if (errors && errors.length > 0) {
            let errorString;
            if (errors[0] === 'LOCATION_EXIST') {
                errorString = this.props.strings.locationExist;
            } else if (errors[0] === 'LOCATION_HAS_CREDIT_NOTES') {
                errorString = this.props.strings.locationHasCreditNotes;
            } else {
                errorString = this.props.strings.generalError;
            }
            errorMessage = <div className="alert-danger">{errorString}</div>;
        }
        return errorMessage;
    },

    getCards(address, info) {
        const objectCard = (
            <EditLargeCard
                title={this.props.strings.address}
                handleSubmit={this._handleObjectForm}
                validationEnabled
                submitLabel={this.props.strings.saveSection}
            >
                <ObjectAddressForm
                    address={address}
                    showPropagateGpsLocationCheckbox
                    forceValidation
                />
                <ShowOnDisabled>
                    {this.getDeleteErrorMessage()}
                    <ConfirmButton
                        danger
                        onConfirmedAction={() => this._removeMansion()}
                        linkClassName="icon icon-wew-trash icon-sm"
                        confirmTitle={this.props.strings.deleteModal.title}
                        confirmMessage={
                            this.props.strings.deleteModal.description
                        }
                        confirmAction={this.props.strings.deleteModal.confirm}
                        rejectAction={this.props.strings.deleteModal.cancel}
                    >
                        <span
                            className="btn btn-action"
                            style={{
                                marginLeft: '1em',
                            }}
                        >
                            {this.props.strings.delete}
                        </span>
                    </ConfirmButton>
                </ShowOnDisabled>
            </EditLargeCard>
        );
        const objectInfoCard = (
            <EditLargeCard
                title={this.props.strings.info}
                optional="(optional)"
                handleSubmit={this._handleObjectInfoForm}
                validationEnabled
                submitLabel={this.props.strings.saveSection}
            >
                <ObjectInfoForm info={info} forceValidation />
            </EditLargeCard>
        );
        return { objectCard, objectInfoCard };
    },

    _isValid() {
        if (this.getCombinedMansion().id) {
            // if undefined, means nothing was changed, aka valid, otherwise, check if valid.
            return (
                this.state.isObjectFormValid === undefined ||
                this.state.isObjectFormValid
            );
        } else {
            return this.state.isObjectFormValid;
        }
    },

    _handleWholeForm(event) {
        event.preventDefault();
        if (this._isValid()) {
            goToMansionOverview();
        }
    },

    _handleObjectForm(address) {
        const valid = address._valid;
        const object = _.extend(this.getCombinedMansion(), {
            address: address,
        });
        object.update_all_locations = address.updateAllLocations;
        delete object.address._valid;
        if (valid) {
            this.props.UpdateMansion(object);
        } else {
            console.log('Alert user!'); //TODO: should be a pop-up modal
        }
        this.setState({ object: object, isObjectFormValid: valid });
    },

    _handleObjectInfoForm(info) {
        const object = _.extend(this.getCombinedMansion(), {
            mansion_type: info.mansion_type,
            num_of_machines: info.num_of_machines,
            housing_units: info.housing_units,
        });
        this.props.UpdateMansion(object);
        this.setState({ object: object });
    },

    render() {
        const object = this.getCombinedMansion();
        if (object) {
            const address = object.address;
            const info = {
                mansion_type: object.mansion_type,
                num_of_machines: object.num_of_machines,
                housing_units: object.housing_units,
            };
            const { objectCard, objectInfoCard } = this.getCards(address, info);
            return (
                <Row>
                    <LeftSide>
                        <TitleCard
                            title={[
                                this.props.strings.edit1,
                                this.props.strings.edit2,
                            ]}
                            left={{
                                content: (
                                    <Link
                                        to={`/objects/${this.props.params.object_id}`}
                                        className="icon icon-wew-arrow-left icon-sm"
                                    />
                                ),
                                title: this.props.strings.cancel,
                            }}
                        />
                    </LeftSide>
                    <Col xs={6} className="col-middle">
                        {objectCard}
                        {objectInfoCard}
                    </Col>
                </Row>
            );
        } else {
            return <div />;
        }
    },
});

export default connect(
    (rootState) => ({
        mansionsById: rootState.mansions.mansionsById,
        removeMansionErrors:
            rootState.pbRequest[PbRequest.REMOVE_MANSION].errors,
        loadMansionRequestStatus:
            rootState.pbRequest[PbRequest.LOAD_MANSIONS].status,
    }),
    { LoadMansions, UpdateMansion, RemoveMansion }
)(translate('EditObject')(withParams(EditObject)));
